import React, { useState, useEffect, useCallback } from 'react';
import { useSpring, animated } from 'react-spring';
import { Slider } from 'antd';

const BlindType = ({ selectedItem, handlePostData, action }) => {
  const [percentState, setPercentState] = useState(
    selectedItem.deviceState.percentControl !== undefined
      ? selectedItem.deviceState.percentControl
      : Number(selectedItem.deviceState.percentState)
  );
  const [height, setHeight] = useState(percentState);

  const handleTransition = useCallback(type => {
    const slider = document.getElementsByClassName('ant-slider-handle');
    const blindHeight = document.getElementsByClassName('blind-height');

    if (type === 'transition') {
      slider[0].style.transitionDuration = '0.3s';
      blindHeight[0].style.transitionDuration = '0.5s';
    } else {
      slider[0].style.transitionDuration = '5s';
      blindHeight[0].style.transitionDelay = '0';
      blindHeight[0].style.transitionDuration = '0.5s';
    }
  }, []);

  const getPercent = useCallback(() => {
    if (selectedItem.deviceState.percentControl !== undefined) {
      return selectedItem.deviceState.percentControl;
    } else {
      return Number(selectedItem.deviceState.percentState);
    }
  }, [
    selectedItem.deviceState.percentState,
    selectedItem.deviceState.percentControl
  ]);

  useEffect(() => {
    const percent = getPercent();

    setPercentState(percent);
    setHeight(percent);

    handleTransition('no-transition');
  }, [handleTransition, getPercent]);

  const onChangeBlind = useCallback(
    value => {
      setPercentState(value);
      handleTransition('transition');
      action();
    },
    [handleTransition, action]
  );

  const onChangeBlindComplete = useCallback(() => {
    setHeight(percentState);
    handleTransition('transition');

    handlePostData('percentControl', percentState, 'Blind');
    action();
  }, [percentState, handleTransition, action, handlePostData]);

  const handleBlindOpenClose = useCallback(
    state => () => {
      const percentState = state === 'open' ? 100 : 0;

      handleTransition('no-transition');
      action();
      handlePostData('percentControl', percentState, 'Blind');
    },
    [action, handlePostData, handleTransition]
  );

  const handlePercentageOptions = useCallback(
    value => () => {
      handleTransition('no-transition');
      action();
      handlePostData('percentControl', value, 'Blind');
    },
    [handleTransition, action, handlePostData]
  );

  const springHeight = useSpring({
    from: {
      height: `calc(${height < 50 ? 100 - height - 5 : 100 - height}% - 5px)`
    },
    to: async next => {
      await next({
        height: `calc(${height < 50 ? 100 - height - 5 : 100 - height}% - 5px)`
      });
    }
  });

  return (
    <section className="device-setting-body blind-wrap">
      <div className="device-display blind">
        <div className="display">
          <div className="blind-setting"></div>
          <div className="blind-images">
            <animated.div
              className="blind-wrap blind-height"
              style={{ height: springHeight.height }}
            >
              <p></p>
            </animated.div>
            <Slider
              vertical
              value={percentState}
              min={0}
              max={100}
              onChange={onChangeBlind}
              tooltipVisible={false}
              onAfterChange={onChangeBlindComplete}
              trackStyle={{ background: 'transparent' }}
            />
          </div>
          <p className="blind-percentage">{percentState}%</p>
        </div>
      </div>
      <div className="device-control-wrap">
        <div className="blind-split-percentage">
          <p onClick={handlePercentageOptions(0)}>0%</p>
          <p onClick={handlePercentageOptions(20)}>20%</p>
          <p onClick={handlePercentageOptions(50)}>50%</p>
          <p onClick={handlePercentageOptions(70)}>70%</p>
          <p onClick={handlePercentageOptions(100)}>100%</p>
        </div>
        <div className="blind-control">
          <p onClick={handleBlindOpenClose('open')}>
            <strong>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.7587 2H17.2413C18.0463 1.99999 18.7106 1.99998 19.2518 2.04419C19.8139 2.09012 20.3306 2.18868 20.816 2.43597C21.5686 2.81947 22.1805 3.43139 22.564 4.18404C22.8113 4.66937 22.9099 5.18608 22.9558 5.74817C23 6.28936 23 6.95372 23 7.75868V8C23 8.55229 22.5523 9 22 9H18.618L18.2168 9.80255L18.7071 10.2929C19.0115 10.5973 19.0869 11.0622 18.8944 11.4472L17.8944 13.4472C17.725 13.786 17.3788 14 17 14H3C2.65342 14 2.33156 13.8205 2.14935 13.5257C1.96714 13.2309 1.95058 12.8628 2.10557 12.5528L2.78324 11.1975L2.29289 10.7071C1.98853 10.4027 1.91308 9.93778 2.10557 9.55279L2.38197 9H2C1.44772 9 1 8.55229 1 8L1 7.7587C0.999988 6.95373 0.999977 6.28937 1.04419 5.74817C1.09012 5.18608 1.18868 4.66937 1.43597 4.18404C1.81947 3.43139 2.43139 2.81947 3.18404 2.43597C3.66937 2.18868 4.18608 2.09012 4.74817 2.04419C5.28937 1.99998 5.95373 1.99999 6.7587 2ZM20.9982 7C20.9951 6.55447 20.9864 6.20463 20.9624 5.91104C20.9266 5.47262 20.8617 5.24842 20.782 5.09202C20.5903 4.7157 20.2843 4.40973 19.908 4.21799C19.7516 4.1383 19.5274 4.07337 19.089 4.03755C18.6389 4.00078 18.0566 4 17.2 4H6.8C5.94342 4 5.36113 4.00078 4.91104 4.03755C4.47262 4.07337 4.24842 4.1383 4.09202 4.21799C3.7157 4.40973 3.40973 4.7157 3.21799 5.09202C3.1383 5.24842 3.07337 5.47262 3.03755 5.91104C3.01357 6.20463 3.00489 6.55447 3.00176 7H20.9982ZM4.61804 9L4.36804 9.5H16.132L16.382 9H4.61804ZM16.632 11.5H4.86803L4.61803 12H16.382L16.632 11.5ZM20 12V9.00001L22 9V12H20ZM20 17V14H22V17H20ZM20 22V19H22V22H20Z"
                  fill="#8A8B8D"
                />
              </svg>
            </strong>
            <span>열기</span>
          </p>
          <p onClick={handleBlindOpenClose('close')}>
            <strong>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.7587 2H17.2413C18.0463 1.99999 18.7106 1.99998 19.2518 2.04419C19.8139 2.09012 20.3306 2.18868 20.816 2.43597C21.5686 2.81947 22.1805 3.43139 22.564 4.18404C22.8113 4.66937 22.9099 5.18608 22.9558 5.74817C23 6.28936 23 6.95372 23 7.75868V8C23 8.55229 22.5523 9 22 9H18.8022L18.0274 12.4865L18.9701 16.2575C19.0078 16.4081 19.0099 16.5654 18.9762 16.7169L17.9762 21.2169C17.8745 21.6745 17.4687 22 17 22H3C2.69668 22 2.40975 21.8623 2.21996 21.6257C2.03016 21.3891 1.95801 21.0792 2.02381 20.7831L2.9726 16.5135L2.02986 12.7425C1.99221 12.5919 1.99014 12.4346 2.02381 12.2831L2.75339 9H2C1.44772 9 1 8.55229 1 8L1 7.7587C0.999988 6.95373 0.999977 6.28937 1.04419 5.74817C1.09012 5.18608 1.18868 4.66937 1.43597 4.18404C1.81947 3.43139 2.43139 2.81947 3.18404 2.43597C3.66937 2.18868 4.18608 2.09012 4.74817 2.04419C5.28937 1.99998 5.95373 1.99999 6.7587 2ZM20.9982 7C20.9951 6.55447 20.9864 6.20463 20.9624 5.91104C20.9266 5.47262 20.8617 5.24842 20.782 5.09202C20.5903 4.7157 20.2843 4.40973 19.908 4.21799C19.7516 4.1383 19.5274 4.07337 19.089 4.03755C18.6389 4.00078 18.0566 4 17.2 4H6.8C5.94342 4 5.36113 4.00078 4.91104 4.03755C4.47262 4.07337 4.24842 4.1383 4.09202 4.21799C3.7157 4.40973 3.40973 4.7157 3.21799 5.09202C3.1383 5.24842 3.07337 5.47262 3.03755 5.91104C3.01357 6.20463 3.00489 6.55447 3.00176 7H20.9982ZM4.80217 9L4.24662 11.5H16.1978L16.7534 9H4.80217ZM16.2192 13.5H4.28078L4.78078 15.5H16.7192L16.2192 13.5ZM16.7534 17.5H4.80217L4.24662 20H16.1978L16.7534 17.5ZM20 12V9.00001L22 9V12H20ZM20 17V14H22V17H20ZM20 22V19H22V22H20Z"
                  fill="#8A8B8D"
                />
              </svg>
            </strong>
            <span>닫기</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default BlindType;
